<template>
    <el-dialog
        :visible.sync="dialogVisible"
        title="释放资源"
        :close-on-press-escape="false"
        width="800px"
        append-to-body
        :before-close="handleClose">
        <div>
            <div class="mb20">
                <h4 class="title-group mb10">资源详情：</h4>
                <div class="pl20" v-loading="dataLoading">
                    <p v-if="resourcesData.length<=0">暂无数据</p>
                    <el-tag class="r-tag mr20 mb10" v-for="(item,index) in resourcesData" :key="index">{{item}}</el-tag>
                </div>
            </div>
            <div class="mb20">
                <h4 class="title-group mb10">释放说明：</h4>
                <div class="pl20">释放后将：{{noteText||'--'}}</div>
                <!--<div class="pl20">释放后将：关闭日报自动生成，关闭风控预警与投放提醒，关闭负责账户的广告定时操作任务，取消账户被授权。</div>-->
            </div>
        </div>
        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" class="action-btn ml20">确定释放
            </el-button>
        </div>
    </el-dialog>
</template>

<script>
    import API from '@/api/department.js';

    export default {
        name: "MemberReleaseModal",
        components: {},
        props: {
            user:{
                required: true,
                type:Object,
            }
        },
        data() {
            return {
                dialogVisible: false,
                submitLoading: false,
                dataLoading:false,
                resourcesData:[],
                noteText:'',

            }
        },
        methods: {
            handleClose() {
                this.dialogVisible = false;
            },
            showModal() {
                this.dialogVisible = true;
                this.$nextTick(() => {
                    this.getUserResources();
                })
            },
            getUserResources(){
                this.dataLoading = true;
                API.getReleaseResourceDetail({
                    id:this.user.id,
                }).then(res => {
                    let resData = res.data||{};
                    this.resourcesData = resData.detail||[];
                    this.noteText = resData.note||'';
                    this.dataLoading = false;
                }, (err) => {
                    console.log('getUserResources error', err);
                    this.resourcesData = [];
                    this.dataLoading = false;
                });

            },
            handleSubmit() {
                API.userRelease({
                    id:this.user.id,
                }).then(res => {
                    this.$message.success(res.info || '操作成功');
                    this.$emit('update');
                    this.dialogVisible = false;
                }, (err) => {
                    console.log('userRelease error', err);
                    this.$message.error(err.info || '操作失败');
                    this.submitLoading = false;
                });
            },

        }
    }
</script>

<style lang="scss" scoped>
    .action-btn {
        width: 120px;
    }



</style>
